(() => {
  const initialiseNavigation = (scope = document) => {
    const headers = scope.matches?.('[data-neps-navigation]')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('[data-neps-navigation]') || []);

    headers.forEach((header) => {
      if (header.dataset.nepsNavigationReady === 'true') return;
      header.dataset.nepsNavigationReady = 'true';

      const desktopNav = header.querySelector('[data-neps-desktop-nav]');
      const desktopItems = desktopNav
        ? Array.from(desktopNav.querySelectorAll(':scope > details[data-neps-nav-item]'))
        : [];
      const mobileNav = header.querySelector('details[data-neps-mobile-nav]');
      const mobileGroups = mobileNav
        ? Array.from(mobileNav.querySelectorAll('details[data-neps-mobile-group]'))
        : [];

      const setExpanded = (details) => {
        const summary = details?.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      const closeDetails = (details) => {
        if (!details) return;
        details.removeAttribute('open');
        setExpanded(details);
      };

      const closeDesktopMenus = (except = null) => {
        desktopItems.forEach((item) => {
          if (item !== except && item.open) closeDetails(item);
        });
      };

      const closeMobileGroups = (except = null) => {
        mobileGroups.forEach((group) => {
          if (group !== except && group.open) closeDetails(group);
        });
      };

      desktopItems.forEach((item) => {
        setExpanded(item);
        item.addEventListener('toggle', () => {
          setExpanded(item);
          if (item.open) {
            closeDesktopMenus(item);
            closeMobileGroups();
            closeDetails(mobileNav);
          }
        });
      });

      if (mobileNav) {
        setExpanded(mobileNav);
        mobileNav.addEventListener('toggle', () => {
          setExpanded(mobileNav);
          if (mobileNav.open) closeDesktopMenus();
          if (!mobileNav.open) closeMobileGroups();
        });
      }

      mobileGroups.forEach((group) => {
        setExpanded(group);
        group.addEventListener('toggle', () => {
          setExpanded(group);
          if (group.open) closeMobileGroups(group);
        });
      });

      header.querySelectorAll('.neps43-dropdown a, .neps43-nav__desktop > a').forEach((link) => {
        link.addEventListener('click', () => closeDesktopMenus());
      });

      header.querySelectorAll('.neps43-mobile-nav__menu a, .neps43-mobile-nav__panel a').forEach((link) => {
        link.addEventListener('click', () => {
          closeMobileGroups();
          closeDetails(mobileNav);
        });
      });

      document.addEventListener('pointerdown', (event) => {
        if (!header.contains(event.target)) {
          closeDesktopMenus();
          closeMobileGroups();
          closeDetails(mobileNav);
          return;
        }

        if (desktopNav && !desktopNav.contains(event.target)) closeDesktopMenus();
      });

      document.addEventListener('focusin', (event) => {
        if (desktopNav && !desktopNav.contains(event.target)) closeDesktopMenus();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        const openDesktop = desktopItems.find((item) => item.open);
        const openMobileGroup = mobileGroups.find((group) => group.open);

        if (openDesktop) {
          const summary = openDesktop.querySelector(':scope > summary');
          closeDesktopMenus();
          summary?.focus();
          return;
        }

        if (openMobileGroup) {
          const summary = openMobileGroup.querySelector(':scope > summary');
          closeMobileGroups();
          summary?.focus();
          return;
        }

        if (mobileNav?.open) {
          const summary = mobileNav.querySelector(':scope > summary');
          closeDetails(mobileNav);
          summary?.focus();
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseNavigation(document), { once: true });
  } else {
    initialiseNavigation(document);
  }

  document.addEventListener('shopify:section:load', (event) => initialiseNavigation(event.target));
})();
